let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hYKL1")).then(() => parcelRequire('9Uve2'));